import React from 'react';

import PropTypes from 'prop-types';

import RightFootInteractive from './RightFootInteractive';
import RightFootOutline from './RightFootOutline';

const RightFoot = ({
  outlineColor,
  disabledColor,
  getColor,
  onChange,
  initialSelectedParts,
  disabled,
  anklesDisabled,
  instepDisabled,
  lowDisabled
}) => (
  <g id={'zoomed-right-foot'}>
    <RightFootOutline
      outlineColor={outlineColor}
      disabledColor={disabledColor}
      disabled={disabled}
    />
    {!disabled && (
      <RightFootInteractive
        getColor={getColor}
        onChange={onChange}
        initialSelectedParts={initialSelectedParts}
        anklesDisabled={anklesDisabled}
        instepDisabled={instepDisabled}
        lowDisabled={lowDisabled}
      />
    )}
  </g>
);

RightFoot.propTypes = {
  outlineColor: PropTypes.string.isRequired,
  disabledColor: PropTypes.string.isRequired,
  getColor: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  initialSelectedParts: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  anklesDisabled: PropTypes.bool,
  instepDisabled: PropTypes.bool,
  lowDisabled: PropTypes.bool
};

RightFoot.defaultProps = {
  onChange: undefined,
  initialSelectedParts: [],
  disabled: false,
  anklesDisabled: undefined,
  instepDisabled: undefined,
  lowDisabled: undefined
};

export default RightFoot;
